import { ReactNode, useEffect, useState } from "react";
import clsx from "clsx";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import Icon3D from "./icon-3d";
import { Tone } from "./tones";

// ----------------------- COUNT UP ON CHANGE ------------------------------------
export function useCountUp(target: number, durationMs = 700) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    let frame = 0;
    const start = performance.now();
    const from = 0;
    const tick = (now: number) => {
      const progress = Math.min(1, (now - start) / durationMs);
      setValue(Math.round(from + (target - from) * (1 - Math.pow(1 - progress, 3))));
      if (progress < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [target, durationMs]);

  return value;
}

type Props = { label: string; value: number; suffix?: string; icon: IconDefinition; tone: Tone; note?: ReactNode; className?: string };

export default function StatTile({ label, value, suffix, icon, tone, note, className }: Props) {
  const shown = useCountUp(value);
  return (
    <div className={clsx("glass glass-hover flex items-start gap-4 p-5", className)}>
      <Icon3D icon={icon} tone={tone} size="lg" />
      <div className="min-w-0">
        <p className="font-[Gilroy-Medium] text-[13px] text-light-gray">{label}</p>
        <p className="mt-0.5 font-[Gilroy-Bold] text-[28px] leading-none tabular-nums text-heading-color">
          {shown.toLocaleString()}
          {suffix ? <span className="ml-0.5 text-[16px] text-light-gray">{suffix}</span> : null}
        </p>
        {note ? <p className="mt-1.5 truncate font-[Gilroy-Medium] text-[12px] text-label-muted">{note}</p> : null}
      </div>
    </div>
  );
}
